import React from 'react';
import { cn } from '../../../utils/cn';

export type ChipTone =
  | 'neutral'
  | 'brand'
  | 'warn'
  | 'danger'
  | 'success'
  | 'info'
  | 'outline';

const TONES: Record<ChipTone, string> = {
  neutral:
    'bg-[rgba(15,23,21,.05)] text-[var(--rt-ink-700)] dark:bg-white/[.06] dark:text-zinc-300',
  brand:
    'bg-[var(--rt-brand-50)] text-[var(--rt-brand-700)] dark:bg-[var(--rt-brand-500)]/12 dark:text-[var(--rt-brand-300)]',
  warn: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300',
  danger: 'bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-300',
  success:
    'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300',
  info: 'bg-sky-50 text-sky-700 dark:bg-sky-500/10 dark:text-sky-300',
  outline:
    'bg-transparent text-[var(--rt-ink-700)] dark:text-zinc-300 border border-[rgba(15,23,21,.12)] dark:border-white/10',
};

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone;
  children: React.ReactNode;
}

export const Chip: React.FC<ChipProps> = ({
  tone = 'neutral',
  children,
  className,
  ...rest
}) => (
  <span
    {...rest}
    className={cn(
      'inline-flex items-center gap-1 h-6 px-2 rounded-full text-[11px] font-medium whitespace-nowrap',
      TONES[tone],
      className,
    )}
  >
    {children}
  </span>
);

export default Chip;
